var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "has-crossprice" }, [
    _vm.showCrossPrice && _vm.isSet && this.currentVariation.item.rebate > 0
      ? _c("div", { staticClass: "crossprice" }, [
          _c("del", { staticClass: "text-muted small text-appearance" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("itemCrossPrice")(
                    _vm._f("currency")(
                      _vm.setNoRebatePrice,
                      _vm.currentVariation.prices.set.currency
                    )
                  )
                ) +
                "\n        "
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", { staticClass: "price h1" }, [
      _c(
        "span",
        [
          !_vm.isVariationSelected || _vm.isSetLoading
            ? [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate(
                        "Ceres::Template." + _vm.dynamicTranslationKey,
                        {
                          price: _vm.$options.filters.currency(
                            _vm.dynamicPrice,
                            _vm.currentVariation.prices.set.currency
                          )
                        }
                      )
                    ) +
                    "\n            "
                )
              ]
            : [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("currency")(
                        _vm.dynamicPrice,
                        _vm.currentVariation.prices.set.currency
                      )
                    ) +
                    "\n            "
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("sup", [
        _vm._v(_vm._s(_vm.$translate("Ceres::Template.singleItemFootnote1")))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }